export default "__VITE_ASSET__D981vSJh__"